import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';

export class TestimonialCarousel {

	el: HTMLElement
	// @ts-ignore
	swiper: Swiper
	nextEl: HTMLElement
	prevEl: HTMLElement
	paginationEl: HTMLElement
    
	constructor(el) {
		this.el = el.querySelector('.swiper')
        this.nextEl = el.querySelector('.button-next')
        this.prevEl = el.querySelector('.button-prev')
        this.paginationEl = el.querySelector('.swiper-pagination')
		this.init()
	}

	init() {
		this.swiper = new Swiper(this.el, {
			modules: [EffectFade, Navigation, Pagination],
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			speed: 500,
			slidesPerView: 1,
			allowTouchMove: true,
			navigation: {
				nextEl: this.nextEl,
				prevEl: this.prevEl,
			},
			pagination: {
				el: this.paginationEl,
				clickable: true,
			},
		})
	}
}